import { getOwner } from '@ember/owner';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';
import Countries from 'frontend-utils/utils/countries';
import GeneralCountryFlag from 'lumen/components/general/country-flag';

interface ParityTablesCellsTdPosCountrySignature {
  Args: {
    cellData: string;
  };
}

export default class ParityTablesCellsTdPosCountry extends Component<ParityTablesCellsTdPosCountrySignature> {
  // @ts-expect-error: Argument of type 'Owner | undefined' is not assignable to parameter of type 'Owner'.
  countries = new Countries(getOwner(this));

  get countryCode(): string | null {
    return this.args.cellData?.toLowerCase() || null;
  }

  get countryName(): string | null {
    if (this.args.cellData) {
      return this.countries.getName(this.args.cellData.toUpperCase());
    }

    return null;
  }

  <template>
    <div class="flex items-center justify-center">
      {{#if this.countryCode}}
        <GeneralCountryFlag @countryCode={{this.countryCode}} @size="medium" />
        {{#if this.countryName}}
          <EmberTooltip @side="right" @tooltipClass="default-tooltip">
            {{this.countryName}}
          </EmberTooltip>
        {{/if}}
      {{else}}
        {{t "general.missing"}}
      {{/if}}
    </div>
  </template>
}
